import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { atomSelectRuleTypeModalIsOpen } from '@/src/modules/AutomationModuleNew/atoms/automationAtoms';

export const useCreateRule = () => {
  const [selectRuleTypeModalIsOpen, setSelectRuleTypeModalIsOpen] = useAtom(
    atomSelectRuleTypeModalIsOpen
  );

  const handleToggleSelectRuleTypeModal = useCallback(() => {
    setSelectRuleTypeModalIsOpen((prev) => !prev);
  }, [setSelectRuleTypeModalIsOpen]);

  return { selectRuleTypeModalIsOpen, handleToggleSelectRuleTypeModal };
};
